import { useCallback, useMemo, useSyncExternalStore } from "react";
import { buildCartStorageKey } from "@/components/cart/helpers/cartStorage";
import { subscribeCartChanges } from "@/components/cart/helpers/cartEvents";

export const useCartStorageRaw = (menuId: number | null): string => {
  const storageKey = useMemo(() => {
    if (!menuId) return null;
    return buildCartStorageKey(menuId);
  }, [menuId]);

  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      if (!menuId) return () => {};
      return subscribeCartChanges(menuId, onStoreChange);
    },
    [menuId]
  );

  const getSnapshot = useCallback(() => {
    if (!storageKey) return "";
    return localStorage.getItem(storageKey) ?? "";
  }, [storageKey]);

  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};
